import React, { memo, useEffect, useLayoutEffect } from 'react';
import {
  Link,
  Redirect,
  useHistory,
  useLocation,
  withRouter,
} from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import classnames from 'classnames';

import { UserActions } from '../../store/actions/users';
import { CompanyActions } from '../../store/actions/companies';

import Tooltip from '../Tooltip';

import BotError from './BotError';
import Notifications from './Notifications';
import Versions from './Versions';
import Publish from './Publish';
import OrganizationsSelect from './OrganizationsSelect';
import ProfileMenu from './ProfileMenu';

import boteria from '../../assets/images/logo-boteria.svg';
import boteria2 from '../../assets/images/ico_boteria.svg';
import ponto from '../../assets/images/ponto-interrogacao.svg';
import iconStar from '../../assets/images/icon_star.svg';
import configuracao from '../../assets/images/configurações.svg';
import criador from '../../assets/images/criador.svg';
import ia from '../../assets/images/IA.svg';
import canais from '../../assets/images/Canais.svg';
import analise from '../../assets/images/análise.svg';

import './styles.scss';

function Header(props) {
  const { pagetype } = props;

  const items = useSelector((state) => state.items.list);
  const { bot } = useSelector((state) => state.bots);
  const isAuthenticated = useSelector(
    (state) => state.auth.authStatus.isLoggedIn
  );
  const user = useSelector((state) => state.users.signedUser);
  const claimIsRoot = useSelector((state) => state.users.signedUserIsRoot);
  const company = useSelector((state) => state.companies.company);
  const organizations = useSelector(
    (state) => state.companies?.organizations || []
  );

  const { pathname } = useLocation();
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (!user?._id) {
      dispatch(UserActions.me());
    }

    if (user && user?.selectedCompany) {
      dispatch(
        CompanyActions.getCompany({ companyId: user.selectedCompany._id })
      );

      if (organizations.length === 0) {
        dispatch(
          CompanyActions.getOrganizations({
            companyId: user.selectedCompany._id,
          })
        );
      }
    }
  }, [user]);

  useLayoutEffect(() => {
    if (claimIsRoot) return;

    if (user?.tfa && company?.tfa) {
      const userHasTfaActive = user?.tfa?.active;
      const selectedCompanyHasTfaActive = company?.tfa === true;

      const redirectToProfile =
        selectedCompanyHasTfaActive && !userHasTfaActive;

      if (redirectToProfile) {
        history.replace(`/user/${user?._id}`);
      }
    }
  }, [user]);

  function isActiveTab(botPath) {
    const currentBotPath = pathname.split('/')[3];
    return currentBotPath === botPath;
  }

  const hasOrganizationSelect =
    (user &&
      user.organizations &&
      user.selectedCompany &&
      user.organizations.filter((e) => {
        return e.companyId === user.selectedCompany._id;
      }).length > 1) ||
    (claimIsRoot &&
      user &&
      user.selectedCompany &&
      organizations.filter((e) => {
        return e.companyId === user.selectedCompany._id;
      }).length > 1);

  if (!bot) {
    return false;
  }

  if (!isAuthenticated) {
    return <Redirect to={{ pathname: '/auth', state: { from: location } }} />;
  }

  const [pagePath] = location.pathname.split('/').slice(-1);

  return (
    <div className={`row linha-menu ${pagetype}`}>
      <div className="col-md-12">
        <nav className="navbar navbar-expand-lg navbar-light fixed-top">
          <div className="navbar-left-side">
            <div className="navbar-brand img-boteria-header">
              <Link to="/">
                <img
                  alt=""
                  className=""
                  style={
                    pagetype === 'page-inicio'
                      ? { marginLeft: 10 }
                      : { marginLeft: 0 }
                  }
                  src={pagetype === 'page-inicio' ? boteria : boteria2}
                />
              </Link>
            </div>

            <div className="menu-bot">
              <Link to={`/bots/${bot._id}/overview`}>
                <small>{bot.title}</small>
              </Link>
            </div>

            {pagePath === 'criador' && bot?.type !== 'voice' && (
              <Versions bot={bot} />
            )}
          </div>

          {bot?.type !== 'voice' && (
            <div className="menu-topo menu-principal">
              <div className="menu-container">
                <ul>
                  <li>
                    <Tooltip render={() => 'Configurações'}>
                      <Link
                        to={`/bots/${bot._id}/configuracoes`}
                        className={classnames({
                          'menu-topo-ativo': isActiveTab('configuracoes'),
                        })}
                      >
                        <img src={configuracao} alt="Icon settings" />
                      </Link>
                    </Tooltip>
                  </li>

                  <li>
                    <Tooltip render={() => 'Criador'}>
                      <Link
                        to={`/bots/${bot._id}/criador`}
                        className={classnames({
                          'menu-topo-ativo': isActiveTab('criador'),
                        })}
                      >
                        <img src={criador} alt="Icon builder" />
                      </Link>
                    </Tooltip>
                  </li>

                  <li>
                    <img
                      src={iconStar}
                      className="icon-menu"
                      alt="Icon start"
                    />
                    <Tooltip render={() => 'Inteligência Artificial'}>
                      <Link
                        to={`/bots/${bot._id}/inteligencia`}
                        className={classnames({
                          'menu-topo-ativo': isActiveTab('inteligencia'),
                        })}
                      >
                        <img src={ia} alt="Icon builder" />
                      </Link>
                    </Tooltip>
                  </li>

                  <li>
                    <Tooltip render={() => 'Canais'}>
                      <Link
                        to={`/bots/${bot._id}/canais`}
                        className={classnames({
                          'menu-topo-ativo': isActiveTab('canais'),
                        })}
                      >
                        <img src={canais} alt="Icon channels" />
                      </Link>
                    </Tooltip>
                  </li>

                  <li>
                    <Tooltip render={() => 'Análise'}>
                      <Link
                        to={`/bots/${bot._id}/analise`}
                        className={classnames({
                          'menu-topo-ativo': isActiveTab('analise'),
                        })}
                      >
                        <img src={analise} alt="Icon analyse" />
                      </Link>
                    </Tooltip>
                  </li>
                </ul>
              </div>
            </div>
          )}

          <div className="navbar-right-side">
            {pagePath === 'criador' && (
              <>
                <BotError />
                <Publish bot={bot} items={items} />
              </>
            )}

            {hasOrganizationSelect && (
              <OrganizationsSelect user={user} organizations={organizations} />
            )}

            <a
              target="_BLANK"
              rel="noopener noreferrer"
              href="https://code7.com/faq/boteria/"
            >
              <Tooltip render={() => 'Ajuda'}>
                <img alt="" src={ponto} />
              </Tooltip>
            </a>

            {bot && bot.type !== 'voice' && <Notifications />}

            <ProfileMenu user={user} />
          </div>
        </nav>
      </div>
    </div>
  );
}

export default withRouter(memo(Header));
